import { defineStore } from 'pinia';
import casinoserve from '@/services/casinoserve.js'
import emitter from '@/services/eventbus.js'

export const useSliderStore = defineStore('slider', {
  state: () => ({
    images: [],
    isFetched: false,
  }),

  getters: {

    slider: () => (carousel) =>
      ['home', 'freebet', 'epl', 'bethub', 'sambazastake', 'leaderboard', 'referrals', 'promotions', 'event'].some(keyword =>
        carousel.link.includes(keyword)
      ) || carousel.status === 1,

    sliderApp: () => (carousel) => carousel.link === 'app' || carousel.status === 1,
    sliderCasino: () => (carousel) => ['casino'].some(keyword => carousel.link.includes(keyword)) || carousel.status === 1,
    sliderAviator: () => (carousel) => carousel.link === 'aviatormiles' || carousel.status === 1,
    sliderESoccer: () => (carousel) =>
      ['esoccer', 'epl', 'profile', 'bets'].some(keyword => carousel.link.includes(keyword)) || carousel.status === 1,
    sliderEuros: () => (carousel) => ['epl','promotions'].some(keyword => carousel.link.includes(keyword)) || carousel.status === 1,
    sliderFreebet: () => (carousel) =>
      ['freebet', 'app', 'epl'].some(keyword => carousel.link.includes(keyword)) || carousel.status === 1,
    sliderJackpot: () => (carousel) => carousel.link === 'profile' || carousel.status === 1,
    sliderVirtuals: () => (carousel) =>
      ['virtualgames', 'jetx', 'freebet', 'epl', 'ligisoo'].some(keyword => carousel.link.includes(keyword)) || carousel.status === 1,
    sliderLeader: () => (carousel) => carousel.link === 'leaderboard' || carousel.status === 1,
    isSpecificLink: () => (link) => (carousel) => carousel.link === link || carousel.status === 1,

    routeFilters(state) {
      return {
        home: state.slider,
        app: state.sliderApp,
        sport: state.slider,
        codehub: state.slider,
        faqs: state.slider,
        help: state.slider,
        policy: state.slider,
        promos: state.slider,
        'promotions-single': state.slider,
        referrals: state.slider,
        responsible: state.slider,
        selfexclusioon: state.slider,
        spinnwin: state.slider,
        support: state.slider,
        terms: state.slider,
        'how-to-play': state.slider,
        'jackpot-terms': state.slider,
        'jackpot-results': state.slider,
        casino: state.sliderCasino,
        crashgames: state.sliderCasino,
        casinoProvider: state.sliderCasino,
        imoon: state.sliderCasino,
        jetx: state.sliderCasino,
        poker: state.sliderCasino,
        pragmatic: state.sliderCasino,
        tablegames: state.sliderCasino,
        virtuals: state.sliderVirtuals,
        virtualgames: state.sliderVirtuals,
        epl: state.sliderEuros,
        europa: state.sliderEuros,
        ucl: state.sliderEuros,
        freebet: state.sliderFreebet,
        jackpot: state.sliderJackpot,
        esoccer: state.sliderESoccer,
        aviatormiles: state.sliderAviator,
        leaderboard: state.slider,
      };
    },
  },

  actions: {
    async fetchCarousels() {
      if (!this.isFetched) {
        try {
          const path = `${import.meta.env.VITE_BASE_CASINOSERVE_URL}/promo/carousel`;
          const response = await casinoserve.get(path);

          this.images = response.data.map((item) => {
            return {
              src: item.image_url,
              alt: item.promo_name,
              link: item.redirect_url,
            };
          });
          this.isFetched = true;

        } catch (error) {
          console.error("Error fetching carousels:", error);
        }
      }
    }
  }
});